import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";

export type CreateTransactionRequest = {
  id_simulacao: string;
  value: number;
  Prazo: number;
  customerId: string;
};

export type CreateTransactionResponse = {
  _id: string;
  contract: string;
  reason_to_cancel: string;
  value: number;
  status: string;
  history: any[];
  seller: string;
  customer: string;
  team: string;
  table: string;
  type: PartnerType;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export async function createTransaction(
  payload: CreateTransactionRequest,
): Promise<CreateTransactionResponse> {
  const { data } = await httpClient
    .post<CreateTransactionResponse>("/c6/transaction", payload, {
      journey: PartnerType.C6,
    })
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
